<breadcrumb [breadcrumbList]="breadcrumbList"></breadcrumb>
<div *ngIf="pageLoading1 || pageLoading2" class="loader text-center">
	<img src="../assets/img/loading.gif" />
</div>
<div class="row g-1">
	<div class="col-6">
		<div class="card">
			<div class="card-header bg-theme">
				<h5 class="card-title mb-0 p-0 fw-bold">
					Reference No.: {{refNo}}
				</h5>
			</div>
			<div class="card-body px-1 pt-1 pb-2">
				<div class="row g-1 mt-2">
					<div class="col">
						<ng-select appendTo="body" [items]="apptList" bindLabel="name" bindValue="encrypt_id"
							[clearable]="false" [multiple]="false" [(ngModel)]="selectedAppt" placeholder="Candidate"
							[appearance]="'outline'" (change)="getScore()">
							<ng-template ng-label-tmp let-item="item">
								<app-gender-icon [gender]="item.gender"></app-gender-icon>
								{{item.name}}
							</ng-template>
							<ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
								<app-gender-icon [gender]="item.gender"></app-gender-icon>
								{{item.name}}
							</ng-template>
						</ng-select>
					</div>
				</div>
				@if(selectedApptWithScore){
				<div class="row g-1 mt-2">
					<div class="col">
						<div class="input-group input-group-sm">
							<label class="input-group-text text-primary">
								<fa-icon [icon]="['fas','building']" matTooltip="Company"></fa-icon>
							</label>
							<div class="form-control">{{selectedApptWithScore?.company}}</div>
						</div>
					</div>
				</div>
				<div class="row g-1 mt-2">
					<div class="col">
						<div class="input-group input-group-sm">
							<label class="input-group-text text-danger">
								<fa-icon [icon]="['fas','star']" matTooltip="Rank"></fa-icon>
							</label>
							<div class="form-control">{{selectedApptWithScore?.rank}}</div>
						</div>
					</div>
					<div class="col">
						<div class="input-group input-group-sm">
							<label class="input-group-text text-success">
								<fa-icon [icon]="['fas','calendar']" matTooltip="Date"></fa-icon>
							</label>
							<div class="form-control">{{formatDate(selectedApptWithScore?.doe)}}</div>
						</div>
					</div>
				</div>
				<div class="row mt-2">
					<div class="col">
						<table class="table table-bordered table-hover table-striped queans-table my-1">
							<thead>
								<tr>
									<th>Scale</th>
									<th class="text-end">Score</th>
								</tr>
							</thead>
							<tbody>
								@for (item of selectedApptWithScore?.scale_score; track $index) {
								<tr>
									<td>
										{{item.scale}}
									</td>
									<td class="text-end">
										{{item.score}}
									</td>
								</tr>
								}
								@if(!selectedApptWithScore?.scale_score.length){
								<tr>
									<td colspan="2" class="text-center">
										Score not found
									</td>
								</tr>
								}
							</tbody>
						</table>
					</div>
				</div>
				}
				<div class="row mt-2">
					<div class="col">
						<a class="btn btn-sm btn-outline-dark ms-1" [routerLink]="[homeRoute]">
							Back
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>
	@if(selectedApptWithScore){
	<div class="col-6">
		<div class="card">
			<div class="card-header bg-theme">
				<h5 class="card-title mb-0 p-0 fw-bold">
					Report
				</h5>
			</div>
			<div class="card-body px-1 pt-1 pb-2">
				<div class="row">
					<div class="col"></div>
				</div>
			</div>
		</div>
	</div>
	}
</div>